import { Base } from './base';

export class CircleNumberType extends Base {
  // source: http://xahlee.info/comp/unicode_circled_numbers.html
	protected data = [
    {
      name: "⓪",
      typeVal: 0,
    },
    {
      name: '①',
      typeVal: 1,
    },
    {
      name: '②',
      typeVal: 2,
    },
    {
      name: '③',
      typeVal: 3,
    },
    {
      name: '④',
      typeVal: 4,
    },
    {
      name: '⑤',
      typeVal: 5,
    },
    {
      name: '⑥',
      typeVal: 6,
    },
    {
      name: '⑦',
      typeVal: 7,
    },
    {
      name: '⑧',
      typeVal: 8,
    },
    {
      name: '⑨',
      typeVal: 9,
    },
    {
      name: '⑩',
      typeVal: 10,
    },
    {
      name: '⑪',
      typeVal: 11,
    },
    {
      name: '⑫',
      typeVal: 12,
    },
    {
      name: '⑬',
      typeVal: 13,
    },
    {
      name: '⑭',
      typeVal: 14,
    },
    {
      name: '⑮',
      typeVal: 15,
    },
    {
      name: '⑯',
      typeVal: 16,
    },
    {
      name: '⑰',
      typeVal: 17,
    },
    {
      name: '⑱',
      typeVal: 18,
    },
    {
      name: '⑲',
      typeVal: 19,
    },
    {
      name: '⑳',
      typeVal: 20,
    },
    {
      name: '㉑',
      typeVal: 21,
    },
    {
      name: '㉒',
      typeVal: 22,
    },
    {
      name: '㉓',
      typeVal: 23,
    },
    {
      name: '㉔',
      typeVal: 24,
    },
    {
      name: '㉕',
      typeVal: 25,
    },
    {
      name: '㉖',
      typeVal: 26,
    },
    {
      name: '㉗',
      typeVal: 27,
    },
    {
      name: '㉘',
      typeVal: 28,
    },
    {
      name: '㉙',
      typeVal: 29,
    },
    {
      name: '㉚',
      typeVal: 30,
    },
    {
      name: '㉛',
      typeVal: 31,
    },
    {
      name: '㉜',
      typeVal: 32,
    },
    {
      name: '㉝',
      typeVal: 33,
    },
    {
      name: '㉞',
      typeVal: 34,
    },
    {
      name: '㉟',
      typeVal: 35,
    },
    {
      name: '㊱',
      typeVal: 36,
    },
    {
      name: '㊲',
      typeVal: 37,
    },
    {
      name: '㊳',
      typeVal: 38,
    },
    {
      name: '㊴',
      typeVal: 39,
    },
    {
      name: '㊵',
      typeVal: 40,
    },
    {
      name: '㊶',
      typeVal: 41,
    },
    {
      name: '㊷',
      typeVal: 42,
    },
    {
      name: '㊸',
      typeVal: 43,
    },
    {
      name: '㊹',
      typeVal: 44,
    },
    {
      name: '㊺',
      typeVal: 45,
    },
    {
      name: '㊻',
      typeVal: 46,
    },
    {
      name: '㊼',
      typeVal: 47,
    },
    {
      name: '㊽',
      typeVal: 48,
    },
    {
      name: '㊾',
      typeVal: 49,
    },
    {
      name: '㊿',
      typeVal: 50,
    }
  ];
}


// WEBPACK FOOTER //
// ./src/app/services/Enums/circleNumberType.ts